export default __webpack_public_path__ + "static/media/icon-google.9c2d204b.svg";